import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import AppFooter from "@/components/AppFooter";
import AppHeader from "@/components/AppHeader";
import AdminHeader from "@/components/admin/AdminHeader";
import { ToastProgrammatic as Toast } from 'buefy';
export default {
  name: 'app',
  components: {
    AppHeader: AppHeader,
    AppFooter: AppFooter,
    AdminHeader: AdminHeader
  },
  beforeCreate: function beforeCreate() {
    var _this = this;
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if ([400, 401].includes(err.response.status) && err.response.config && !err.response.config.__isRetryRequest) {
          if (['sessionExpired', 'unauthorized', 'invalidAuthorizationToken'].includes(err.response.data.errorCode)) {
            Toast.open('Sua sessão expirou');
            if (err.response.data.errorCode !== 'invalidAuthorizationToken') {
              localStorage.removeItem('user-token');
              localStorage.removeItem('restriction');
              _this.$store.commit('authNone');
            }
            // if you ever get an unauthorized, logout the user
            if (_this.$store.getters.token) {
              _this.$store.dispatch('authLogout').then(function () {
                _this.$router.push({
                  path: '/login'
                });
              });
            } else {
              _this.$router.push({
                path: '/login'
              });
            }
          }
        }
        reject(err.response);
      });
    });
  }
};